import React from "react";
import SettingEditorField from "./settingEditorField";
import {Button, ButtonGroup} from "reactstrap";
import {useMutation, useQueryClient} from "react-query";
import {useLoggedInApi} from "../../../../api";
import {toast} from "react-toastify";


export default function SettingEditor({data, toggleEditMode}) {
    const {id, key, setting_type, value} = data;

    const [newValue, setNewValue] = React.useState(value);


    const isChanged = newValue !== value;

    const api = useLoggedInApi()
    const queryClient = useQueryClient();

    const saveMutation = useMutation(() => {
        const resource = api.resource('payment/settings/');
        const data = ['json', 'payment_method'].includes(setting_type) ?
            {"new_value_json": newValue} : {new_value: newValue};
        const updatePromise = resource.patchItem(id, data)
        return toast.promise(updatePromise, {
            pending: "Saving changes...",
            success: "Changes saved successfully.",
            error: "Something went wrong. Please try again."
        })
    }, {
        onSuccess: () => {
            // queryClient.invalidateQueries(['table', 'payment/settings']);
            queryClient.invalidateQueries(['payment', 'settings']);
            toggleEditMode();
        },
        onError: (error) => {
            console.error("Error saving setting:", error);
        }
    })


    return (
        <>
            <SettingEditorField
                label={key}
                originalValue={value}
                value={newValue}
                setValue={setNewValue}
                settingType={setting_type}
            />

            <ButtonGroup className="float-end " color="primary">

                <Button className="btn-sm" disabled={!isChanged} onClick={() => {
                    saveMutation.mutate();
                }}>
                    Save
                </Button>
                <Button className="btn-sm text-white" color="danger" onClick={toggleEditMode}>
                    Cancel
                </Button>
            </ButtonGroup>
        </>
    )

}